export const financePageJA = {
  "hero": {
    "title": "AIトレーディングアシスタント",
    "lead": "リアルタイムデータに基づく暗号資産および株式市場向け。当社のソフトウェア開発ビジネスユニットはファイナンス・ビジネスユニットと連携し、[IDD主導](idd)（Intent-Driven Development）かつ[Veridion](veridion)による自動化のもとでトレーディングアシスタントを開発・継続的に進化させています。AI社員が価格、出来高、ボラティリティ、オーダーブック、テクニカル指標、感情分析付き金融ニュースをリアルタイムで評価します。"
  },
  "analysis": {
    "title": "対話によるデータ分析",
    "paragraphs": [
      "対話では、[Veridion](veridion)によってオーケストレーションされたファイナンス・ビジネスユニットのAI社員が、収集されたすべての市場データ、指標、ニュースに直接アクセスし、直接の対話で質問に回答します。",
      "エージェントは、データプロファイルを作成し、自由に選んだ列について相関と回帰を計算し、7種類のグラフを描き、予測の的中精度を実際の価格と照らし合わせて検証し、閾値やストップロスを別の値にして取引判断を再計算します。最新のニュースとそのセンチメント、今後予定されている企業イベントも分析に織り込みます。",
      "数値は実行されたツールの結果からのみ採用し、ツールの結果を装った回答は、表示される前にプラットフォームが破棄します。あいまいな点がある場合は、データに触れる前に一度だけ確認の質問を行い、どのような手順を踏んだかは回答の横にあるアクティビティ表示に示されます。"
    ]
  },
  "features": {
    "title": "機能",
    "items": [
      {
        "title": "証券口座とデモ口座",
        "text": "お使いの証券口座を連携すると、保有銘柄、注文、口座残高、書類をアシスタント上で確認できます。デモ口座では、実際の資金を使わずに現在の相場で取引できます。",
        "facts": "金融商品ごとのTAN承認による実取引 · 保有中の取引、取引記録、損益を表示する注文一覧 · メールによる日次レポート"
      },
      {
        "title": "機械学習による予測",
        "text": "金融商品ごとに専用のモデルを用意しています。モデルは価格の推移、チャートパターン、統計的指標、ニュースのセンチメントから学習し、毎日、数百のモデルを最新のデータで再学習しています。価格は市場に応じて1〜4分ごとに更新され、30分足が確定するたびに新しい予測を生成して保存し、実際の価格と比較します。",
        "facts": "2,000本の木からなるランダムフォレスト · MACD、RSI、ボリンジャーバンド、ADX、チャートパターン · MAE、RMSE、MAPE、的中率"
      },
      {
        "title": "ニュースとセンチメント",
        "text": "多数のRSS配信元から、経済ニュースと株式市場のニュースを2分ごとに取得します。金融テキストに特化した言語モデルが各ニュースのセンチメントをポジティブ、ニュートラル、ネガティブのいずれかに判定し、直近15分から4時間のセンチメントは、時間とともに減衰する重みで予測に反映されます。",
        "facts": "自社GPU上で稼働する言語モデル · 企業イベントのカレンダー"
      },
      {
        "title": "シグナルと自動売買",
        "text": "シグナルは、予測がエントリー閾値を上回り、かつ市場構造またはチャートパターンがそれを裏付けたときに発生します。自動売買機能はポジションを建て、残りの上昇余地が保有閾値を上回っている間は保有を続け、ストップロスに達したとき、または取引終了前に決済します。",
        "facts": "信用を利用しないロングポジションのみ · 閾値、ストップロス、投入額を金融商品ごとに設定可能"
      },
      {
        "title": "バックテスト",
        "text": "取引シミュレーションは、自由に記述したエントリーとエグジットを、実際の市場データに対して精算します。予測バックテストは、保存された予測履歴を3つの方式で再生します。",
        "facts": "取引回数、勝率、累積リターン、最大ドローダウン、プロフィットファクター"
      },
      {
        "title": "ワークスペースと対象市場",
        "text": "チャート、分析、ニュース、ポートフォリオ、戦略、注文一覧、ブローカレッジ、データテーブル、アシスタントが、移動可能なウィンドウとして並びます。チャートには、価格と予測曲線が、指標や検出されたチャートパターンとともに表示されます。",
        "facts": "DAX 40、MDAX、TecDAX、EURO STOXX 50、Dow Jones、Nasdaq 100、Nikkei 225 · EUR/USD、EUR/GBP · Bitcoin · 2分から12時間までの間隔"
      },
      {
        "title": "運用",
        "text": "アプリケーションは当社独自のプラットフォーム上で稼働し、ログインした各ユーザーは、他から分離された専用のインスタンスで作業します。ログインには第二の認証要素が必要で、すべてのAI呼び出しは、固定の利用枠を設けた一つの中央アクセスポイントを経由します。",
        "facts": ""
      }
    ]
  },
  "cta": {
    "title": "利用のお申し込み",
    "subtitle": "トレーディングアシスタントは、当社プラットフォーム上でサブスクリプションとしてご利用いただけます。ご連絡いただければ、喜んでアクセスを設定いたします。",
    "button": "利用を申し込む",
    "subject": "AIトレーディングアシスタントの利用申し込み"
  }
};
